document.addEventListener('DOMContentLoaded', function() {
  const calloutDiv = document.getElementById('dynamic-discount-callout-snippet');
  if (!calloutDiv) return;
  
  const calloutContent = calloutDiv.querySelector('.custom-dynamic-callout-content');
  if (!calloutContent) return;
  
  const blackFridayMessage = '<span class="highlight-white">BLACK FRIDAY SALE</span>, DISCOUNT APPLIED AT CHECKOUT';
  const percentMessage = '<span class="highlight-white">Save {X}%</span> when you use coupon <span class="highlight-white">code {Y}</span> at checkout.';
  const amountMessage = '<span class="highlight-white">Save ${X}</span> when you use coupon <span class="highlight-white">code {Y}</span> at checkout.';
  
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  
  const ref = getUrlParameter('ref');
  const discountPercentage = getUrlParameter('discount_percent');
  const discountAmount = getUrlParameter('discount_amount');
  const couponCode = getUrlParameter('coupon_code');
  
  let message = '';
  let hasDiscount = false;

  if (ref === 'BLACKFRIDAY') {
    message = blackFridayMessage;
    hasDiscount = true;
  } else if (discountPercentage && couponCode) {
    message = percentMessage.replace('{X}', discountPercentage).replace('{Y}', couponCode);
    hasDiscount = true;
  } else if (discountAmount && couponCode) {
    message = amountMessage.replace('{X}', discountAmount).replace('{Y}', couponCode);
    hasDiscount = true;
  }

  if (hasDiscount) {
    calloutContent.innerHTML = message;
    calloutDiv.classList.add('visible');
  } else {
    calloutDiv.classList.remove('visible');
  }
});